<div class="bg-card p-0 m-0">
  <div class="flex flex-row items-center gap-1 justify-content-between" mat-dialog-title>
    <mat-icon
      *ngIf="delete || givenIcon"
      [svgIcon]="givenIcon || 'heroicons_solid:exclamation'"
    ></mat-icon>
    <h2 class="text-2xl font-bold">{{ title }}</h2>
  </div>

  <div mat-dialog-content class="flex flex-col gap-5 align-center">
    <div class="text-secondary text-lg leading-normal">
      {{ message }}
      <p *ngIf="italicMessage" class="my-2 text-secondary italic">
        <span class="text-white">{{ 'Note' | transloco }}:</span> {{ italicMessage }}
      </p>
      <ul class="list-disc list-inside text-white my-1">
        <li *ngFor="let bullet of bullets">{{ bullet }}</li>
      </ul>
    </div>
  </div>

  <div mat-dialog-actions class="flex justify-end" [ngClass]="buttonsAlign ?? ''">
    <button mat-button (click)="onDismiss()" class="mat-dense" mat-raised-button>
      {{ cancelButtonText ?? ('Cancel' | transloco) }}
    </button>
    <button
      *ngIf="middleButtonText"
      mat-raised-button
      class="mat-dense"
      (click)="onMiddle()"
      [ngClass]="{
        'm-2': buttonsAlign === 'center',
        'bg-warn': middleTextBG === 'warn'
      }"
    >
      {{ middleButtonText || okButtonText }}
    </button>
    <button
      *ngIf="!hideActionBtn"
      mat-raised-button
      [color]="delete ? 'warn' : 'primary'"
      class="mat-dense"
      [disabled]="isYesButtonDisabled || disableMainAction"
      (click)="onConfirm()"
      [ngClass]="buttonsAlign === 'center' ? 'm-2' : ''"
    >
      {{
        isYesButtonDisabled
          ? (actionButtonText || okButtonText) + '(' + countdown + ') '
          : actionButtonText || okButtonText
      }}
    </button>
  </div>
</div>
